import React from 'react'

import Button from 'app/components/ButtonDefault'
import './styles.scss'
import AvailableDomain from 'app/components/SVGS/AvailableDomain'
import { PAUSE_BUTTONS } from 'app/constants/pauseButtons'
import { IPauseOrOutOfOfficeProps } from './interface'
import { EColors } from 'app/constants/colors'

const bc = 'pause-or-of-office'

const svgProps = {
  viewBox: '0 0 16 16',
  background: EColors.WHITE,
  checkcolor: EColors.WHITE,
  circleborder: EColors.BLUE,
  width: '20px',
  height: '20px',
  style: { marginBottom: '2px' },
}

const activeIcon = {
  background: EColors.WHITE,
  circleborder: EColors.BLUE,
  checkcolor: EColors.BLUE,
}

const { STOP_LEVEL, OUT_OF_OFFICE } = PAUSE_BUTTONS

const PauseOrOutOfOffice: React.FC<IPauseOrOutOfOfficeProps> = ({
  outBtn = 'Take a break or go on vacation/out of office',
  pauseBtn = 'Stop ProHabits indefinitely',
  setState,
  state,
}) => {
  return (
    <div className={`${bc}__body`}>
      <Button
        style={{ marginBottom: '8px' }}
        className={`${bc}__button`}
        icon={<AvailableDomain {...svgProps} {...(state === OUT_OF_OFFICE && activeIcon)} />}
        onClick={() => {
          setState(OUT_OF_OFFICE)
        }}
      >
        <span className={`${bc}__text`}>{outBtn}</span>
      </Button>
      <Button
        className={`${bc}__button`}
        icon={<AvailableDomain {...svgProps} {...(state === STOP_LEVEL && activeIcon)} />}
        onClick={() => {
          setState(STOP_LEVEL)
        }}
      >
        <span className={`${bc}__text`}>{pauseBtn}</span>
      </Button>
    </div>
  )
}

export default PauseOrOutOfOffice
